<template>
  <div class="section">
    <div>
      <img
        :src="images.title1"
        style="height: auto; width: 25%; margin-left: 50px; margin-top: 35px"
      />
      <img
        :src="images.logo"
        style="
          height: auto;
          width: 15%;
          float: right;
          margin-right: 50px;
          margin-top: 40px;
        "
      />
    </div>
    <div style="padding: 60px 40px 0px 40px">
      <p style="text-indent: 40px; line-height: 30px; margin-top: -30px">
        心理健康状态测评从
        <span
          v-for="(items, index) in name1"
          :key="index"
          style="font-weight: bold"
        >
          <span v-if="index != name1.length - 1"> {{ items }}、 </span>
          <span v-else> {{ items }} </span>
        </span>
        维度，评估测试者心理健康状态的倾向性。
      </p>
    </div>
    <div class="image-inline">
      <div class="image-inner" :class="getImgNumClass()">
        <div class="img" v-for="(name, index) in name1" :key="index">
          <img :src="getImg(index + 1)" style="height: auto; max-width: 80px" />
          <div class="name" v-text="name"></div>
        </div>
      </div>
    </div>

    <div style="padding: 10px 10px 10px 5px">
      <p style="text-indent: 40px; line-height: 30px; margin-top: -30px">
        以下为{{ this.name }}在各个维度的得分情况：
      </p>
    </div>
    <div style="background-color: #f4f7f9; padding-bottom: 19px">
      <latitudeRadar
        v-if="result && result.length > 0"
        :model="model"
        :result="result"
        :score="this.score"
        :name1="this.name1"
      />

      <img
        :src="images.title"
        style="height: auto%; width: 20%; margin-left: 320px"
      />
    </div>
    <div style="padding: 50px 190px 0px 50px">
      <p style="text-indent: 40px; line-height: 30px; margin-top: -30px">
        {{ content3 }}
      </p>
    </div>
    <!-- <div style="text-align: center;margin-top:35px">
      <img :src="images.page" style="height:auto%;width:5%;" />
    </div> -->
  </div>
</template>

<script>
import { pageThree } from "@/views/report/config/three";
import latitudeRadar from "@/components/dataView/echarts/latitudeRadar";
export default {
  props: ["model", "name", "result", "score", "name1"],
  components: { latitudeRadar },
  data() {
    return {
      images: {
        logo: require("../../../assets/images/page1/logo.png"),
        title1: require("../../../assets/images/page4/title1.png"),
        back1: require("../../../assets/images/page4/back1.png"),
        back2: require("../../../assets/images/page4/back2.png"),
        back3: require("../../../assets/images/page4/back3.png"),
        back4: require("../../../assets/images/page4/back4.png"),
        back5: require("../../../assets/images/page4/back5.png"),
        back6: require("../../../assets/images/page4/back6.png"),
        back7: require("../../../assets/images/page4/back7.png"),
        back8: require("../../../assets/images/page4/back8.png"),
        back9: require("../../../assets/images/page4/back9.png"),
        back10: require("../../../assets/images/page4/back10.png"),
        title: require("../../../assets/images/page4/title.png"),
        page: require("../../../assets/images/page4/page.png"),
      },
      content1: pageThree.content1,
      content2: pageThree.content2,
      content3: pageThree.content3,
      content4: pageThree.content4,
      content5: pageThree.content5,
    };
  },
  methods: {
    getImg(index) {
      return this.images["back" + index];
    },
    getImgNumClass(index) {
      return "imgNum" + this.name1.length;
    },
  },
};
</script>

<style lang="scss" scoped>
.section {
  page-break-before: always;
  page-break-after: always;
  page-break-inside: avoid;
  height: 1124px; //A4纸的高度像素
  background-size: 100% 100%;
  background-image: url("../../../assets/images/page4/bg.png");
  overflow: hidden;
}
.image-inline {
  text-align: center;
  height: 200px;
  padding-top: 10px;
  width: 100%;
  display: flex;
}
.image-inner {
  width: 100%;
  height: auto;
  margin: 0px auto;
  padding: 10px 40px 0px;
  &.imgNum1 .img {
    width: 100%;
  }
  &.imgNum2 .img {
    width: 50%;
  }
  &.imgNum3 .img {
    width: 33.33%;
  }
  &.imgNum4 .img {
    width: 25%;
  }
  &.imgNum5 .img {
    width: 20%;
  }
  &.imgNum6 .img {
    width: 16.6%;
  }
  &.imgNum7 .img {
    width: 14.2%;
  }
  &.imgNum8 .img {
    width: 12.5%;
  }
  &.imgNum9 .img {
    width: 11.1%;
  }
  &.imgNum10 .img {
    width: 10%;
  }
  .img {
    margin: auto;
    display: inline-block;
    .name {
      font-weight: bold;
      margin-top: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/report/three/pageFour.vue